import { textarea } from './textarea';

const form = {

	mutationObserver: null,
	
	elem: {
		$body: $('body'),
		$main: $('main'),
		$selects: $('select:not([multiple]):not([tabindex])'),
		$textarea: $('textarea')
	},

	init() {
		// Init plugins
		textarea.init();
		this.selectability();

		// Watch for DOM changes in <main> and reapply selectability again when they happen
		if(form.elem.$main.length > 0) {
			this.mutationObserver = new MutationObserver(form.selectability);
			this.mutationObserver.observe(document.querySelector('main'), { 'childList': true, 'subtree': true });
		}
		
	},

	// selectability(): apply selectability plug-in to select elements, and update the code to prevent lenis from interfering with their scrollability
	selectability() {
		form.elem.$selects = $('select:not([multiple]):not([tabindex])');
		if (form.elem.$selects.length > 0) {

			form.elem.$selects.selectability({
				'position': 'above',
				'floatLabel': 'true'
			});

			const replacedSelects = document.querySelectorAll('.selectability');
			// Copy over classes from original element and prevent lenis scroll issue
			replacedSelects.forEach((element) => {
				let originalElementClasses = element.nextElementSibling.classList;
				originalElementClasses.forEach(function(classname) {
					if(classname !== 'selectability-offscreen') {
						element.classList.add(classname);
					}
				});
				element.setAttribute('data-lenis-prevent', '');
			});

			$('.selectability[aria-disabled="true"]').attr('tabindex', '-1');
		}
	}

};

export { form };
